<template>
  <div class="ready-shipments-table-row-component">
    <div class="body-item-row">
      <div class="body-item-1">
        <div class="checkbox-decorator" @click="toggleSelectRow(shipment)">
          <i
            v-if="!selectedPackages.includes(shipment)"
            class="fa-regular fa-square fa-fw text-gray5 dark:text-dmText1 text-xl" />
          <i v-else class="fa-solid fa-square-check fa-fw text-brand-primary text-xl" />
        </div>
      </div>
      <div class="body-status flex items-center">
        <ReadyShipmentStatus :item="shipment" class="mr-2" />
      </div>
      <div class="body-item-2 flex items-center">
        <div class="flex flex-col max-w-full">
          <span class="font-medium pb-1">{{ shipment.source }}</span>
          <CopyComponent :text="shipment.source_tracking" />
        </div>
      </div>
      <div class="body-item-3">
        <div class="flex flex-col">
          <span>{{ `${shipment.weight} ${t('site_pro.lb')}` }}</span>
          <span>{{ `${shipment.width} x ${shipment.height} x ${shipment.length} ${t('site_pro.inches')}` }}</span>
        </div>
      </div>
      <div class="body-item-4">{{ getFullYear(shipment.created_at) }}</div>
      <div class="body-item-5">{{ shipment.id }}</div>
      <div class="body-item-6">
        <div
          class="toggle flex items-center justify-around w-10 h-10 bg-neutral7 dark:bg-dmGray3 rounded-full cursor-pointer"
          @click="toggleOpenRow(shipment)">
          <i
            class="fa-solid"
            :class="{
              'fa-chevron-up text-brand-primary': openedPackages.includes(shipment),
              'fa-chevron-down': !openedPackages.includes(shipment),
            }" />
        </div>
      </div>
    </div>

    <div class="body-item-collapsible" :class="{ '!hidden': !openedPackages.includes(shipment) }">
      <div
        class="collapsible-image"
        :style="{ backgroundImage: `url('${shipment.media[0]}')`, backgroundSize: 'cover' }"
        @click="showGalleryModal(shipment)">
        <div
          v-if="shipment.media.length > 1"
          class="flex items-center justify-center bg-black h-full w-full bg-opacity-20 rounded-[0.5rem]">
          <span class="text-lg font-bold text-white">{{ `+${shipment.media.length}` }}</span>
        </div>
      </div>
      <AdditionalServicesDropdown class="mb-1" :item="shipment" @open-modal="handleOpenServiceModal" />

      <ShipmentInspectPackage
        :shipment="shipment"
        @handle-open-services-results-modal="handleOpenServicesResultsModal" />

      <ShipmentExtraPhotos :shipment="shipment" @handle-open-services-results-modal="handleOpenServicesResultsModal" />

      <ShipmentStorageFee :shipment="shipment" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { PackageInterface } from '~/types/shipzeePro/packagesTypes'

import { getFullYear } from '~/utils/date/parseDate'
import PackageAdditionalServiceEnum from '~/enums/PackageAdditionalServiceEnum'

const { t } = useLang()

defineProps<{
  shipment: PackageInterface
  openedPackages: PackageInterface[]
  selectedPackages: PackageInterface[]
}>()

const emit = defineEmits([
  'handleOpenServiceModal',
  'handleOpenServicesResultsModal',
  'showGalleryModal',
  'toggleSelectRow',
  'toggleOpenRow',
])

function handleOpenServiceModal(serviceId: PackageAdditionalServiceEnum, itemId: number): void {
  emit('handleOpenServiceModal', serviceId, itemId)
}

function handleOpenServicesResultsModal(shipment: PackageInterface): void {
  emit('handleOpenServicesResultsModal', shipment)
}

function showGalleryModal(shipment: PackageInterface): void {
  emit('showGalleryModal', shipment)
}

function toggleSelectRow(shipment: PackageInterface): void {
  emit('toggleSelectRow', shipment)
}

function toggleOpenRow(shipment: PackageInterface): void {
  emit('toggleOpenRow', shipment)
}
</script>

<style lang="postcss" scoped>
.ready-shipments-table-row-component {
  @apply flex flex-col w-full;

  .collapsible-image {
    @apply flex w-20 h-20 min-w-[5rem] min-h-[5rem] rounded-[0.5rem];
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
}
</style>

<style lang="postcss" scoped>
.wl {
  .toggle {
    @apply bg-brand-primaryLight;
  }
}
</style>
